import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LibService } from './libService';

@Injectable({
  providedIn: 'root',
})
export class ConfService {
  baseApi = environment.rootApiFoundation + 'confs';

  constructor(public libService: LibService) {}

  getConf(id: string) {
    return this.libService.getData<any>(this.baseApi, `/${id.toString()}`);
  }

  getAllConfs(): Observable<any> {
    //console.log(this.baseApi);
    return this.libService.getData<any>(this.baseApi, '');
  }

  updateConf(id: string, conf: any) {
    return this.libService.putData<any>(
      { conf: conf },
      this.baseApi,
      `/${id.toString()}`
    );
  }

  createConf(conf: string) {
    return this.libService.postData<any>({ conf: conf }, this.baseApi, '');
  }
}
